import { useCallback } from 'react';

import { TrackingApi } from 'api/TrackingApi';
import { getScreenOrientationWithSizes } from 'helpers/device';

export const useLimitTimeOfferPopupAnalytics = () => {
  const trackShow = useCallback(() => {
    TrackingApi.trackLimitOfferSeen({
      pageUrl: document.location.href,
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  return {
    trackShow,
  };
};
